module.exports = __webpack_public_path__ + "static/media/csv2.6afcb535.png";